(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire47c9"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire47c9"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kb7iW", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $eb0a804165f70534$export$6503ec6e8aabbaf; }, function (v) { return $eb0a804165f70534$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $eb0a804165f70534$export$f7ad0328861e2f03; }, function (v) { return $eb0a804165f70534$export$f7ad0328861e2f03 = v; });
var $eb0a804165f70534$export$6503ec6e8aabbaf;
var $eb0a804165f70534$export$f7ad0328861e2f03;
"use strict";
var $eb0a804165f70534$var$mapping = new Map();
function $eb0a804165f70534$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$eb0a804165f70534$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $eb0a804165f70534$var$resolve(id) {
    var resolved = $eb0a804165f70534$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$eb0a804165f70534$export$6503ec6e8aabbaf = $eb0a804165f70534$var$register;
$eb0a804165f70534$export$f7ad0328861e2f03 = $eb0a804165f70534$var$resolve;

});

parcelRegister("llf7H", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $f8974a47ebd16c98$export$bdfd709ae4826697; }, function (v) { return $f8974a47ebd16c98$export$bdfd709ae4826697 = v; });
var $f8974a47ebd16c98$export$bdfd709ae4826697;
var $f8974a47ebd16c98$export$c9e73fbda7da57b6;
var $f8974a47ebd16c98$export$5a759dc7a1cfb72a;
"use strict";
var $f8974a47ebd16c98$var$bundleURL = {};
function $f8974a47ebd16c98$var$getBundleURLCached(id) {
    var value = $f8974a47ebd16c98$var$bundleURL[id];
    if (!value) {
        value = $f8974a47ebd16c98$var$getBundleURL();
        $f8974a47ebd16c98$var$bundleURL[id] = value;
    }
    return value;
}
function $f8974a47ebd16c98$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $f8974a47ebd16c98$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $f8974a47ebd16c98$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $f8974a47ebd16c98$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$f8974a47ebd16c98$export$bdfd709ae4826697 = $f8974a47ebd16c98$var$getBundleURLCached;
$f8974a47ebd16c98$export$c9e73fbda7da57b6 = $f8974a47ebd16c98$var$getBaseURL;
$f8974a47ebd16c98$export$5a759dc7a1cfb72a = $f8974a47ebd16c98$var$getOrigin;

});

var $d889cc1ec7ad6488$exports = {};


(parcelRequire("kb7iW")).register((parcelRequire("llf7H")).getBundleURL("2TQZ3"), JSON.parse('["2TQZ3","index.b574b2e9.js","ittYd","game.ef84a2f1.js"]'));

})();
//# sourceMappingURL=index.runtime.1c4e82fe.js.map
